<ng-container *transloco="let t">
  <section
    #descriptionCard
    id="descriptionCard"
    cdk-scrollable
    class="featured-description-card"
    *ngIf="product">
    <span class="fixed-space-16" aria-hidden="true"></span>

    <pre
      class="description column"
      [innerHtml]="description$ | async"
      [style.maxWidth]="((specs$ | async)?.length || 0) > 0 ? '500px' : '100%'"
      [class.read-more]="readMore"></pre>

    <span class="fixed-space-16" aria-hidden="true"></span>
    <span class="expand" *ngIf="!readMore" (click)="readMore = !readMore">
      {{ t('label_show_more') }}
    </span>

    <ng-container *ngIf="(product?.mpn || product?.upc) && readMore">
      <span class="fixed-space-16" aria-hidden="true"></span>

      <ng-container *ngIf="product?.mpn">
        <span class="fixed-space-4" aria-hidden="true"></span>
        <p class="m-0 product-npm"><strong>MPN:</strong> {{ product.mpn }}</p>
      </ng-container>

      <ng-container *ngIf="product?.upc">
        <span class="fixed-space-4" aria-hidden="true"></span>
        <p class="m-0 product-upc"><strong>UPC:</strong> {{ product.upc }}</p>
      </ng-container>
    </ng-container>

    <ng-container *ngIf="((specs$ | async)?.length || 0) > 0">
      <span class="fixed-space-16" aria-hidden="true"></span>
      <table class="specs column">
        <ng-container *ngFor="let spec of specs$ | async; trackBy: trackByKeyVal">
          <tr>
            <td class="key">
              <strong>{{ spec.key }}</strong>
            </td>
            <td class="value">{{ spec.value }}</td>
          </tr>
        </ng-container>
      </table>
    </ng-container>

    <span class="fixed-space-16" aria-hidden="true"></span>
    <span class="expand" *ngIf="readMore" (click)="collapseAndScroll()">
      {{ t('label_show_less') }}
    </span>
  </section>
</ng-container>
